<template>
    <div>
        <div id="rl-topnavarea"/>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                rl_topnav_url: window.rlServerURL.MainWeb + "includes/nav/rl_topnav.html"
            };
        },
        mounted () {
            let vm = this;
            if ($("#rl-topnavarea").length > 0) {
                $("#rl-topnavarea").load(vm.rl_topnav_url, function () {
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/top.vue